import { render, staticRenderFns } from "./workloadAccountingStandards.vue?vue&type=template&id=89edc48c&scoped=true&"
import script from "./workloadAccountingStandards.vue?vue&type=script&lang=js&"
export * from "./workloadAccountingStandards.vue?vue&type=script&lang=js&"
import style0 from "./workloadAccountingStandards.vue?vue&type=style&index=0&id=89edc48c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89edc48c",
  null
  
)

export default component.exports